export default "__VITE_ASSET__15b6a73a__"